import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { getBroadcastContent } from '../_services/HelpServivce';

function BroadcastModel() {
  const [visible, setVisible] = useState(false);
  const [content, setContent] = useState({
    mainHeading: '',
    floatingMessage: '',
    broadCastImage: '',
    mailBody: ''
  });

  useEffect(() => {
  const fetchBroadcast = async () => {
    try {
      const res = await getBroadcastContent();

      if (res.status === 200 && res?.data?.result?.success) {
        const response = res.data.result.details;

        if (response.countryCode === localStorage.getItem("CountryCode")) {
          if (new Date(response.validTo).getTime() > new Date().getTime()) {
            const imageSrc = response.broadCastImage
              ? `data:image/png;base64,${response.broadCastImage}`
              : '';

            setContent({
              mainHeading: response.mainHeading || '',
              floatingMessage: response.floatingMessage || '',
              mailBody: response.mailBody || "",
              broadCastImage: imageSrc
            });

            setVisible(true);
          } else {
            setVisible(false);
          }
        } else {
          setVisible(false);
        }
      } else {
        setVisible(false);
      }
    } catch (err) {
      console.error('Error fetching broadcast:', err);
      setVisible(false);
    }
  };

  fetchBroadcast();
}, []);

  return (
    <>
      {visible && (
        <Modal
          className="broadcastModel"
          centered
          open={visible}
          footer={null}
          maskClosable={true}
          onCancel={() => setVisible(false)}
          width={520}
          bodyStyle={{ padding: 0 }}
        >
          <div style={{ padding: 0 }}>
            {/* Title Row with X icon */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#3b5998',
                color: '#fff',
                padding: '10px',
                margin: 0,
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px'
              }}
            >
              <h2 style={{ margin: 0, color: '#fff', fontSize: "20px" }}>
                {content.mainHeading}
              </h2>
              <i
                className="fas fa-times"
                style={{
                  cursor: 'pointer',
                  fontSize: '13px',
                  color: '#fff'
                }}
                onClick={() => setVisible(false)}
              ></i>
            </div>

            {/* Body */}
            <div style={{ padding: '10px' }}>
              {/* Show floatingMessage if available */}
              {content.floatingMessage && (
                <h4 style={{ marginBottom: '20px', fontSize: "17px" }}>
                  {content.floatingMessage}
                </h4>
              )}

              {/* Layout for content based on what exists */}
              {content.broadCastImage ? (
                content.mailBody || content.floatingMessage ? (
                  // Image + mailBody (or floatingMessage) side by side if mailBody exists
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: content.mailBody ? 'row' : 'column',
                      // alignItems: 'flex-start',
                      gap: '20px'
                    }}
                  >
                    {content.mailBody && (
                      <div style={{ flex: 1, textAlign: 'left' }}>
                        <p>{content.mailBody}</p>
                      </div>
                    )}

                    <div style={{ flex: 1 }}>
                      <img
                        src={content.broadCastImage}
                        alt="broadcast"
                        style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                      />
                    </div>
                  </div>
                ) : (
                  // Only image exists → full width
                  <div>
                    <img
                      src={content.broadCastImage}
                      alt="broadcast"
                      style={{ width: '100%', height: '100%',objectFit: 'cover',display:"block"  }}
                    />
                  </div>
                )
              ) : (
                // Only mailBody exists
                content.mailBody && (
                  <div style={{ textAlign: 'left' }}>
                    <p>{content.mailBody}</p>
                  </div>
                )
              )}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default BroadcastModel;